<div class="loader">
  <div class="loader-element">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <img src="assets/images/logo-transparent.png" alt="logo" title="logo">
  </div>
</div>
